<div>
  <style>
    table, th, td {
      border: 1px solid black !important;
      border-collapse: collapse;
    }

    th, td {
      padding: 6px;
      text-align: left;
    }

    thead th,
    tfoot td,
    tbody td {
      border: 1px solid black !important;
    }

    .table {
      width: 100%;
      margin-left: 20px;
    }

    .noPrint {
      display: inline-block;
    }
  </style>

  <div style="margin-left: 80%; margin-bottom: 2%;">
    <button
      id="print-button"
      class="noPrint"
      style="margin-top: 2%; margin-left: 2%; display: none;"
      mat-raised-button
      color="primary"
      printSectionId="print-section"
      [useExistingCss]="true"
      ngxPrint>
      Print
    </button>

    <button
      (click)="printPage3()"
      class="noPrint"
      style="margin-top: 2%; margin-left: 2%; background-color: #3f51b5; color: white;"
      mat-raised-button
      color="primary">
      Print
    </button>

    <button
      class="noPrint"
      style="margin-top: 2%; margin-left: 2%; background-color: #3f51b5; color: white;"
      (click)="exportExcel('issue_seller_Invoice_Register')"
      mat-raised-button
      color="primary">
      Export
    </button>

    <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
      Close
    </button>
  </div>

  <div id="print-section" style="margin-top: 50px;">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th colspan="2">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक</th>
          <th colspan="2">अंकाचे नाव : &nbsp; {{ newissuedatepp }}</th>
          <th colspan="1">Datewise Briefly</th>
          <th colspan="2">अंकाचे कॅटेगरी : &nbsp; {{ issue_cat }}</th>
          <th colspan="2">Date : From {{ start_date | date: 'dd-MM-yyyy' }} - To {{ end_date | date: 'dd-MM-yyyy' }}</th>
          <th colspan="1">दिनांक : {{ today1 }}</th>
          <th colspan="1">पृष्ठ क्र : 1</th>
        </tr>
        <tr>
          <th style="width: 5%;">Sr</th>
          <th style="width: 15%;">Issue Name</th>
          <th style="width: 15%;">Representative</th>
          <th style="width: 8%; text-align: end;">Issue Copies</th>
          <th style="width: 10%; text-align: end;">Issue Amt</th>
          <th style="width: 10%; text-align: end;">Net Amt</th>
          <th style="width: 10%; text-align: end;">Before Gst</th>
          <th style="width: 10%; text-align: end;">GST Amt</th>
          <th style="width: 10%; text-align: end;">Total Amt</th>
          <th style="width: 10%; text-align: end;">Receive Amt</th>
          <th style="width: 10%; text-align: end;">Pending Amt</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let item1 of inDetailsRegReportdatewise">
          <tr>
            <td colspan="3" style="font-weight: bold;">
              Booking Date: {{ item1.booking_date }}
            </td>
            <td colspan="8"></td>
          </tr>

          <ng-container *ngFor="let item of item1.issue_data; let i = index">
            <tr>
              <td style="font-weight: bold;">{{ item.issue_id }}</td>
              <td>{{ item.issue_seller_name }}</td>
              <td>{{ item.rep_name }}</td>
              <td style="text-align: end;">{{ item.issue_copies }}</td>
              <td style="text-align: end;">{{ item.issue_amt }}</td>
              <td style="text-align: end;">{{ item.net_amount }}</td>
              <td style="text-align: end;">{{ item.beforegst_amt }}</td>
              <td style="text-align: end;">{{ item.gst }}</td>
              <td style="text-align: end;">{{ item.total_amount }}</td>
              <td style="text-align: end;">{{ item.pymt_rcv_amt ||0}}</td>
              <td style="text-align: end;">{{ item.net_amount - item.pymt_rcv_amt}}</td>
            </tr>
          </ng-container>

          <tr style="background-color: #e5ecf9; font-weight: bold;">
            <td>{{ item1.issue_data.length }}</td>
            <td colspan="2" style="text-align: center; font-weight: bold;">एकूण</td>
            <td style="text-align: end; font-weight: bold;">{{ item1.issue_copies }}</td>
            <td style="text-align: end; font-weight: bold;">{{ item1.total_advt_amount }}</td>
            <td style="text-align: end; font-weight: bold;">{{ item1.total_discounted_amt }}</td>
            <td style="text-align: end; font-weight: bold;">{{ item1.total_before_gst }}</td>
            <td style="text-align: end; font-weight: bold;">{{ item1.total_gst }}</td>
            <td style="text-align: end; font-weight: bold;">{{ item1.total_amt }}</td>
            <td style="text-align: end; font-weight: bold;">{{ item1.total_rcv }}</td>
            <td style="text-align: end; font-weight: bold;">{{ item1.total_pending }}</td>
          </tr>
        </ng-container>
      </tbody>

  
     <tr style="background-color:lightyellow; font-weight: bold;">
    <td style="font-weight: bold;">{{ inDetailsRegReportdatewise.length }}</td>
    <td colspan="2" style="text-align: center; font-weight: bold;">एकूण</td>
    <td style="text-align: end; font-weight: bold;">{{ issueCopies }}</td>
    <td style="text-align: end; font-weight: bold;">{{ issue_amt }}</td>
    <td style="text-align: end; font-weight: bold;">{{ total_discounted_amt }}</td>
    <td style="text-align: end; font-weight: bold;">{{ total_before_gst }}</td>
    <td style="text-align: end; font-weight: bold;">{{ totalgst }}</td>
    <td style="text-align: end; font-weight: bold;">{{ netissueamt }}</td>
    <td style="text-align: end; font-weight: bold;">{{ jamatotal }}</td>
    <td style="text-align: end; font-weight: bold;">{{ total_pending }}</td>
  </tr>


</table>
  </div>
</div>
